import { render, staticRenderFns } from "./ProductCardSpecial.vue?vue&type=template&id=eb7c95e4&"
import script from "./ProductCardSpecial.vue?vue&type=script&lang=js&"
export * from "./ProductCardSpecial.vue?vue&type=script&lang=js&"
import style0 from "./ProductCardSpecial.vue?vue&type=style&index=0&id=eb7c95e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VHover } from 'vuetify/lib/components/VHover';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VHover,VRow})
